<template>  
    <section class="section is-small is-white has-text-centered is-long">
        <div class="container is-narrow">
            <h1 class="title is-size-3"> My Portfolio </h1>
            <div class="portfolio-grid">
                <div class="columns is-multiline is-centered">
                    <div class="column is-one-third item-hover" v-for="port in portfolios" :key="port.id">
                        <figure class="image">
                            <img :src="require(`@/assets/img/portfolio/${port.image}`)" alt="">
                            <figcaption>
                                <div class="title">
                                    {{port.title}}
                                </div>
                            </figcaption>
                        </figure>
                    </div>
                </div>
                    <router-link to="/portfolio" class="button is-blue is-rounded is-outlined is-large">See Details</router-link>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    computed: {
        portfolios() {
            return this.$store.state.loadedPortfolio
        }
    }
}
</script>
